/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useToolbarSettings } from 'bundles/coursera-toolbar/hooks/useToolbarSettings';
import type { ButtonProps } from 'bundles/coursera-toolbar/types/Plugin';

import _t from 'i18n!nls/coursera-toolbar';

interface ToolbarButtonProps extends ButtonProps {
  label: string;
}

const styles = {
  button: (isMinimized: boolean) => css`
    background: none;
    border: none;
    color: var(--cds-color-neutral-primary-invert);
    cursor: pointer;
    height: 100%;
    padding: ${isMinimized ? '0 var(--cds-spacing-100)' : '0 var(--cds-spacing-150)'};
    display: flex;
    align-items: center;
    border-right: 1px solid var(--cds-color-grey-900);
    font-size: ${isMinimized ? '11px' : '13px'};

    &:hover {
      background-color: var(--cds-color-grey-950);
    }
  `,

  activeButton: css`
    background-color: var(--cds-color-grey-900);

    &:hover {
      background-color: var(--cds-color-grey-950);
    }
  `,
};

/**
 * Generic button component for the developer toolbar
 */
const ToolbarButton = ({ label, openPanel, isOpen }: ToolbarButtonProps) => {
  const { isMinimized } = useToolbarSettings();
  return (
    <button
      type="button"
      aria-label={`${isMinimized ? label + ': ' : ''} ${_t('Open {label} panel', { label })}`}
      css={[styles.button(isMinimized), isOpen && styles.activeButton]}
      onClick={openPanel}
      data-testid={`toolbar-button-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {!isMinimized && label}
    </button>
  );
};

export default ToolbarButton;
